import InputText from "../Inputs/InputText";
import InputSelect from "../Inputs/InputSelect";
import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import PropTypes from "prop-types";

const ProfileCard = ({
  title,
  description,
  fields = [],
  onUpdate,
  buttonCTA,
  onButtonClick,
  children,
}) => {
  const handleChange = (name, value) => {
    if (onUpdate) {
      onUpdate(name, value);
    }
  };

  return (
    <div className="relative card-base-background card-base-border p-4 mb-2 gap-2 flex flex-col w-full card-base">
      <h2 className="mb-1 font-bold text-lg">{title}</h2>

      {description && (
        <p className="md:text-sm text-base mb-2!">{description}</p>
      )}

      {fields.length > 0 && (
        <div className="flex flex-col gap-2 max-w-80">
          {fields.map((field, idx) => {
            const Component = field.component || InputText;

            return (
              <div className="flex flex-col gap-1" key={idx}>
                <p className="md:text-sm text-sm">{field.label}</p>
                <Component
                  value={field.value}
                  onChange={(e) =>
                    Component === InputSelect
                      ? handleChange(field.name, e.target.value)
                      : handleChange(field.name, e.target.value)
                  }
                  type={field.type}
                  options={field.options}
                />
              </div>
            );
          })}
        </div>
      )}

      {children && <div className="mt-2 md:text">{children}</div>}

      {buttonCTA && (
        <div className="pt-3">
          <BtnSecondaryM
            buttonCTA={buttonCTA}
            onClickLink={onButtonClick || (() => {})}
          />
        </div>
      )}
    </div>
  );
};

ProfileCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  fields: PropTypes.array,
  onUpdate: PropTypes.func,
  buttonCTA: PropTypes.string,
  onButtonClick: PropTypes.func,
  children: PropTypes.node,
};

export default ProfileCard;
